import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  getAllSerialNumbers,
  getSerialNumberForUnit,
} from "@redotech/redo-fulfillment-group-common/scan-serial-numbers";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

export const SerialNumberCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Serial number",
    cell: (row) => {
      return getAllSerialNumbers(row.scanVerifiedItemized).join(", ");
    },
    expandedCsvCell: (row, expansionIndex) => {
      return getSerialNumberForUnit(
        getExpandedItems(row) ?? [],
        expansionIndex,
        row.scanVerifiedItemized,
      );
    },
  };
